import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import '../../components/loader.css';
import ReactLoading from 'react-loading';

const Customer_b2b_pricing_details = () => {
    const { customer_id,product_id, carrier_id } = useParams();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [productData, setProductData] = useState(null);
    const [zones, setZones] = useState([]);
    const [selectedZone, setSelectedZone] = useState("");
    const [pricing, setPricing] = useState({});
    const [loading, setLoading] = useState(false);
   const[cpscstate , setcpsc] = React.useState({carrier_name:[] , product_name:[] , source_city_name:[]})
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };

    useEffect(() => {
        fetchProductData();
        fetchZones();
    }, []);

    useEffect(() => {
        if (selectedZone) fetchPricing();
    }, [selectedZone]);

    const fetchProductData = async () => {
        try {
            let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/get_carrier_product_data`;
            let sendData = { carrier_id:carrier_id , product_id:product_id  }
            const res = await axios.post(full_api,sendData,{ headers: exportValue.headers });
            setProductData(res.data.output[0]);
        } catch (err) {
            console.error("Error fetching product data", err);
        }
    };

    const fetchZones = async () => {
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/fetch_all_b2b_zones`;
        let sendData = { 
         }
        axios.post(full_api, sendData, { headers: exportValue.headers }).then((res)=>{
            setZones(res.data.output)
          
            }).catch((e) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                })
  
                Toast.fire({
                    background: "#206bc4",
                    type: 'unsuccess',
                    title: "Something went wrong",
                    color: "white"
                });
  
            });
    };

    const fetchPricing = async () => {
      try {
        setLoading(true);
        const full_api = `${exportValue.host}/${exportValue.version}/${exportValue.api}/customer_get_pricing_by_from_zone`;
        const sendData = {
          customer_id,
          carrier_id,
          product_id,
          from_zone_id: selectedZone
        };
    
        const res = await axios.post(full_api, sendData, {
          headers: exportValue.headers,
        });
    
        const rawData = res.data.output || [];
        const formattedPricing = {};
    
        rawData.forEach((item) => {
          const toZoneId = item.to_zone_id;
          
          // Handle regular weight ranges
          if (item.start_range !== null && item.end_range !== null) {
            const rangeKey = `${item.start_range}-${item.end_range}`;
            
            if (!formattedPricing[toZoneId]) {
              formattedPricing[toZoneId] = {};
            }
    
            formattedPricing[toZoneId][rangeKey] = {
              base: item.price || '',
              additional: item.additional_price || '',
            };
          }
          // Handle additional weight
          else if (item.start_range === null && item.end_range === null) {
            if (!formattedPricing[toZoneId]) {
              formattedPricing[toZoneId] = {};
            }
    
            formattedPricing[toZoneId].additional = {
              additional: item.additional_price || '',
            };
          }
        });
    
        setPricing(formattedPricing);
      } catch (err) {
        console.error("Error fetching pricing", err);
      } finally {
        setLoading(false);
      }
    };
    const handleInputChange = (zoneId, rangeKey, value, type) => {
      setPricing((prev) => ({
        ...prev,
        [zoneId]: {
          ...prev[zoneId],
          [rangeKey]: {
            ...prev[zoneId]?.[rangeKey],
            [type]: value,
          },
        },
      }));
    };
    const handleSave = async () => {
      try {
        const payload = {
            customer_id:customer_id,
          from_zone_id: selectedZone,
          weight_range: [],
        };
    
        zones.forEach((zone) => {
          const to_zone_id = zone.b2b_zone_id;
    
          // Handle regular weight ranges
          productData?.weight_range.forEach((range) => {
            const rangeKey = `${range.start_range}-${range.end_range}`;
            const pricingEntry = pricing[to_zone_id]?.[rangeKey];
    
            if (pricingEntry && (pricingEntry.base || pricingEntry.additional)) {
              payload.weight_range.push({
                carrier_id: productData.carrier_id,
                product_id: productData.product_id,
                from_zone_id: selectedZone,
                to_zone_id,
                start_range: range.start_range,
                end_range: range.end_range,
                price: pricingEntry.base || null,
                additional_price: pricingEntry.additional || null,
              });
            }
          });
    
          // Handle additional weight if it exists
          if (productData?.additional_weight > 0) {
            const additionalEntry = pricing[to_zone_id]?.additional;
            if (additionalEntry && additionalEntry.additional) {
              payload.weight_range.push({
                carrier_id: productData.carrier_id,
                product_id: productData.product_id,
                from_zone_id: selectedZone,
                to_zone_id,
                start_range: null,
                end_range: null,
                price: null,
                additional_price: additionalEntry.additional || null,
              });
            }
          }
        });
    
        // Now send to API
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/customer_b2b_carrier_product_destination_category_add_api`;
        const res = await axios.post(full_api, payload, { headers: exportValue.headers });
    
        if (res.data.status == "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          });
          Toast.fire({
            background: "#206bc4",
            type: 'success',
            title: "Added Successfully",
            color: "white"
          });
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          });
          Toast.fire({
            background: "#206bc4",
            type: 'error',
            title: "Something went wrong",
            color: "white"
          });
        }
      } catch (err) {
        console.error("Error saving pricing", err);
        alert("Something went wrong.");
      }
    };

    

    return (
        <div>
            <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <section className="home-section">
                <Sub_header />
                <section>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                        <div className="d-block mb-4 mb-md-0">
                            <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                    <li className="breadcrumb-item">
                                        <a href="#">
                                            <svg className="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Products</li>
                                </ol>
                            </nav>
                            <div className="d-flex">
                                <h2 className="h4">{productData?.product_name} (Product ID: {product_id})</h2>
                                {/* <h5 className="ps-2"><span className="badge rounded-pill bg-dark">Carrier: {carrier_id}</span></h5> */}
                                <h5 className="ps-2"><span className="badge rounded-pill bg-warning">Mode: {productData?.mode}</span></h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <select className="form-select" name="from_zone_id" value={selectedZone} onChange={e => setSelectedZone(e.target.value)}>
                            <option value="">Please Select</option>
                            {zones.map(zone => (
                                <option key={zone.b2b_zone_id} value={zone.b2b_zone_id}>{zone.b2b_zone_name}</option>
                            ))}
                        </select>
                    </div>
                </section>
                <section>
                    <ul className="nav nav-tabs justify-content-end">
                        <li className="nav-item">
                            <a className="nav-link active" href="#">Price Chart</a>
                        </li>
                    </ul>
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            {loading ? (
                                <div className="text-center">
                                    <ReactLoading type="spin" color="#000" height={50} width={50} />
                                </div>
                            ) : (
                              <section className="zone_list">
                              <div className="table-responsive">
                                <table className="table table-hover">
                                <thead className="bg-dark1">
  <tr>
    <th className="text-white">ZONE</th>
    {productData?.weight_range.map((sub, index) => (
      <th className="text-white" key={index}>
        {sub.start_range}-{sub.end_range} KG
      </th>
    ))}
    {/* Add additional weight column if it exists */}
    {productData?.additional_weight > 0 && (
      <th className="text-white">Additional {productData.additional_weight} KG</th>
    )}
  </tr>
</thead>
<tbody>
  {selectedZone &&
    zones.map((zone) => (
      <tr key={zone.b2b_zone_id}>
        <td>{zone.b2b_zone_name}</td>

        {productData?.weight_range.map((range, idx) => {
          const rangeKey = `${range.start_range}-${range.end_range}`;
          return (
            <td key={idx}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter price"
                value={pricing[zone.b2b_zone_id]?.[rangeKey]?.base || ''}
                onChange={(e) =>
                  handleInputChange(
                    zone.b2b_zone_id,
                    rangeKey,
                    e.target.value,
                    'base'
                  )
                }
              />
            </td>
          );
        })}

        {/* Additional weight input if it exists */}
        {productData?.additional_weight > 0 && (
          <td>
            <input
              type="text"
              className="form-control"
              placeholder="Additional price"
              value={
                pricing[zone.b2b_zone_id]?.additional?.additional || ''
              }
              onChange={(e) =>
                handleInputChange(
                  zone.b2b_zone_id,
                  'additional',
                  e.target.value,
                  'additional'
                )
              }
            />
          </td>
        )}
      </tr>
    ))}
</tbody>
                                </table>
                              </div>
                            </section>
                            )}
                            <div className="text-end">
                                <button type="button" className="btn btn-primary btn-lg" onClick={handleSave}>Save Pricing</button>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    );
};

export default Customer_b2b_pricing_details;